import { render, staticRenderFns } from "./NewsCate.vue?vue&type=template&id=62f406ea&"
import script from "./NewsCate.vue?vue&type=script&lang=js&"
export * from "./NewsCate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports